import { CheckNetworkIcon } from './CheckNetworkIcon';

/**
 * author: Michael Richins
 * id F1CE2683-FE3F-4AA1-89A2-A935D6FD403C
 * name check-network
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/check-network.svg
 * tags
 */
export const TickNetworkIcon = CheckNetworkIcon;
export default TickNetworkIcon